import { useState } from "@wordpress/element";
import { motion } from "framer-motion";
import Typography from "@mui/material/Typography";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import { Account, Advance } from "./tabs";

const Settings = () => {
	const [tabValue, setTabValue] = useState(0);

	function handleTabChange(event, value) {
		setTabValue(value);
	}

	return (
		<div className="flex flex-col flex-auto shrink-0 w-full">
			<div className="header relative overflow-hidden flex shrink-0 items-center justify-center h-48 sm:h-48">
				<div className="flex flex-col max-w-2xl mx-auto w-full">
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1, transition: { delay: 0 } }}
					>
						<Typography className="text-24 sm:text-44 font-bold tracking-tight">
							Corksy Settings
						</Typography>
					</motion.div>
				</div>
			</div>
			<div className="flex flex-col flex-1 max-w-2xl w-full mx-auto px-8 sm:px-16">
				<Card className="max-w-md rounded-20 shadow h-full min-h-sm">
					<div className="flex">
						<Tabs
							value={tabValue}
							onChange={handleTabChange}
							variant="scrollable"
							scrollButtons="auto"
							classes={{ root: "w-full h-44" }}
						>
							<Tab className="h-44" label="Corksy Account" />
							<Tab className="h-44" label="Advance" />
						</Tabs>
					</div>
					<Divider />

					<CardContent>
						<div className="p-16 pt-10">
							{tabValue === 0 && <Account />}
							{tabValue === 1 && <Advance />}
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	);
};

export default Settings;
